import React, { useState } from "react";
import ToDoList from "./Component/ToDoList";
import ToDoPerformTab from "./Component/ToDoPerformTab";
import BookingDetails from "./Component/BookingDetails";
import DocumentTab from "./Component/DocumentTab";
import ChatTab from "./Component/ChatTab";
import { useParams, useSearchParams } from "react-router-dom";
import { getAllActivities } from "../../redux/actions/todoPerformance";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Analytics from "./Component/Analytics";
import { LOGIN } from "../../redux/constants";
function EmbeddedPerformanceIndex() {
  const [tab, setTab] = useState(1);
  const { company_id, activity_assignment_id, email } = useParams();
  const dispatch = useDispatch();
  const [validation, setValidation] = useState([]);
  const [assetentryvalue, setAssetEntryValue] = useState([{ based_on: "" }]);
  const [activeentry, setActiveEntry] = useState([]);
  const [performancetab, setPerformanceTab] = useState(1);
  const [loader, setLoader] = useState(false);
  const [allowbasedon, setAllowBasedon] = useState(false);
  useEffect(() => {
    setLoader(true);
    dispatch(
      getAllActivities(activity_assignment_id, (res) => {
        setLoader(false);
      })
    );
  }, [activity_assignment_id]);
  useEffect(() => {
    dispatch({
      type: LOGIN,
      payload: {
        email: email,
        company: {
          id: company_id,
        },
      },
    });
  }, [company_id, dispatch, email]);
  return (
    <>
      {loader ? (
        <div className="h-[90vh] flex justify-center items-center">
          <div class="px-6">
            <svg
              className="animate-spin w-12 h-12 fill-current shrink-0"
              viewBox="0 0 16 16"
            >
              <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
            </svg>
          </div>
        </div>
      ) : (
        <div
          className="h-screen flex bg-white px-4"
          style={{ height: "100vh" }}
        >
          {/* ------------------------------ SideBar ----------------------- */}
          <div className="w-full sm:w-1/4">
            <ToDoList
              setValidation={setValidation}
              setAssetEntryValue={setAssetEntryValue}
              setActiveEntry={setActiveEntry}
              setTab={setTab}
              setPerformanceTab={setPerformanceTab}
              setAllowBasedon={setAllowBasedon}
              embedded={true}
            />
          </div>
          <div className={`w-full sm:block sm:w-3/4 min-h-100`}>
            {/* ------------------------------- Tabs ------------------------- */}
            <div className={`sm:block sm:pt-1 sm:pl-5`}>
              <ul
                className="text-sm font-medium flex justify-between flex-nowrap overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9] space-x-12"
                id="tabs-tabJustify"
                role="tablist"
              >
                <li className="text-left">
                  <a
                    href="#tabAdded"
                    className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold  py-2 my-3" +
                  ${
                    tab === 1
                      ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
                      : ""
                  }`}
                    id="tab-added"
                    data-toggle="tab"
                    role="tablist"
                    onClick={(e) => {
                      e.preventDefault();
                      setTab(1);
                    }}
                  >
                    To Do Performance
                  </a>
                </li>
                <li className="text-left">
                  <a
                    href="#tabNotadded"
                    className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 my-3" +
                    ${
                      tab === 2
                        ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
                        : ""
                    }`}
                    id="tab-added"
                    data-toggle="tab"
                    role="tablist"
                    onClick={(e) => {
                      e.preventDefault();
                      setTab(2);
                    }}
                  >
                    Booking Details
                  </a>
                </li>
                <li className="text-left">
                  <a
                    href="#tabNotadded"
                    className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 my-3" +
                    ${
                      tab === 3
                        ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
                        : ""
                    }`}
                    id="tab-added"
                    data-toggle="tab"
                    role="tablist"
                    onClick={(e) => {
                      setTab(3);
                    }}
                  >
                    Documents
                  </a>
                </li>
                {/* <li className="text-left">
                  <a
                    href="#tabNotadded"
                    className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold  py-2 my-3" +
                    ${
                      tab === 4
                        ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
                        : ""
                    }`}
                    id="tab-added"
                    data-toggle="tab"
                    role="tablist"
                    onClick={(e) => {
                      setTab(4);
                    }}
                  >
                    Chat
                  </a>
                </li> */}
                <li className="text-left">
                  <a
                    href="#tabNotadded"
                    className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 my-3" +
                    ${
                      tab === 5
                        ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
                        : ""
                    }`}
                    id="tab-added"
                    data-toggle="tab"
                    role="tablist"
                    onClick={(e) => {
                      e.preventDefault();
                      setTab(5);
                    }}
                  >
                    Analytics
                  </a>
                </li>
              </ul>
            </div>
            {tab === 1 && (
              <ToDoPerformTab
                activity_assignment_id={activity_assignment_id}
                validation={validation}
                setValidation={setValidation}
                assetentryvalue={assetentryvalue}
                setAssetEntryValue={setAssetEntryValue}
                activeentry={activeentry}
                setActiveEntry={setActiveEntry}
                performancetab={performancetab}
                setPerformanceTab={setPerformanceTab}
                allowbasedon={allowbasedon}
                setAllowBasedon={setAllowBasedon}
                embedded={true}
              />
            )}
            {tab === 2 && <BookingDetails embedded={true} />}
            {tab === 3 && <DocumentTab />}
            {/* {tab === 4 && <ChatTab />} */}
            {tab === 5 && <Analytics openTab={tab} />}
          </div>
        </div>
      )}
    </>
  );
}

EmbeddedPerformanceIndex.auth = {
  path: "/todo/performance",
  role: "ALL",
};

export default EmbeddedPerformanceIndex;
